const translations = {
  title: 'Checklists',
  name: 'Name',
  actions: 'Actions',
  availableIn: 'Available in',
  type: 'Type',
  updatedAt: 'Last updated',
  enabled: 'Enabled',
  searchOnlyThisEnvironment: 'Search only in this environment',
  searchOnlyThisEnvironmentTooltip:
    'By default, the search is done in the templates database. When activating this option, the search will be done only in this environment.',
  createNew: 'Create a new one',
  createNewDescription: 'New blank checklist.',
  new: 'New',
  templates: 'Templates'
}

export default translations
